import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {FeatureTypeService, NotificationsService, ProjectService} from '@catcore/services';
import {GenericLinkedResource} from '@catcore/types/base';
import {extractDataFromModel, genericResourceToLinkItem} from '@catcore/utils';
import {GenericResourceService} from '@catfeatures/services/generic-resource.service';
import {ModalService} from '@catmodules/widgets/slide-in-modal/services/modal.service';
import {LinkItem, StyleType} from '@catui/types';
import {ConfirmationService} from 'primeng/primeng';
import {Observable} from 'rxjs/Rx';
import {Subscription} from 'rxjs/Subscription';
import {isNullOrUndefined} from 'util';
import {PanelLinkedListComponent} from '../../../../ui-base/components/panel-linked-list/panel-linked-list.component';
import {GgwDeviceParam} from '../../../ggw-device-params/types';
import {ModifyParameterComponent} from "@catmodels/parameters/components/modify-parameter/modify-parameter.component";

@Component({
  selector: 'cat-parameter-list',
  templateUrl: './parameter-list.component.html',
  styleUrls: ['./parameter-list.component.scss'],
})
export class ParameterListComponent implements OnInit, OnDestroy {

  @ViewChild('itemList') itemList: PanelLinkedListComponent;

  @Output() afterDelete = new EventEmitter();
  @Output() afterUpdate = new EventEmitter<GgwDeviceParam>();

  @Input() featureLevel = false;
  @Input() title = 'Parameters';
  @Input() enableCreate = false;
  @Input() enableFromXml = false;
  @Input() fileList = null;

  linkedResourceParams: LinkItem[] = [];
  modalResourceSubscription: Subscription;

  protected _resource: any;
  selectionMode = false;
  styleType = StyleType;
  protected selectedItems = [];

  @Input()
  set resource(value) {
    this._resource = value;
    if (this._resource) {
      const resourceParams = extractDataFromModel<any>(this._resource, 'parameters');
      this.linkedResourceParams = this.createLinkedParameterList(resourceParams);
      this.linkedResourceParams.sort((a, b) => {
        return (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0);
      });
    }
  }

  get resource() {
    return this._resource;
  }

  constructor(protected modalService: ModalService,
              protected genericService: GenericResourceService,
              protected confirmationService: ConfirmationService,
              protected notificationService: NotificationsService) { }

  ngOnInit() {
  }

  ngOnDestroy() {
  }

  toggleSelectionMode() {
    this.selectionMode = !this.selectionMode;
  }

  onSelectionUpdate(selectedItems) {
    this.selectedItems = selectedItems;
  }

  /**
   *
   */
  deleteSelection() {
    this.confirmationService.confirm({
      message: 'Do you really want to delete ' + this.selectedItems.length + ' parameters?',
      accept: () => {
        const requests = [];
        this.selectedItems.forEach((item: LinkItem) => {
          const service = this.genericService.findServiceForResource(item.resourceUri);
          requests.push(service.delete());
        });
        Observable.forkJoin(requests)
          .subscribe(() => {
            this.notificationService.success('Deletion successful', 'Successfully removed ' + requests.length + ' parameters');
            this.exitSelectionMode();
            this.afterUpdate.emit(null);
          });
      },
    });
  }

  selectAll() {
    this.itemList.selectAll();
  }

  deselectAll() {
    this.itemList.deselectAll();
  }

  private exitSelectionMode() {
    this.selectionMode = false;
  }

  /**
   *
   * @param {GenericLinkedResource[]} resourceParams
   * @returns {LinkItem[]}
   */
  protected createLinkedParameterList(resourceParams: GenericLinkedResource[]) {
    return genericResourceToLinkItem(resourceParams, (value: GenericLinkedResource) => (router: Router) => this.openModifyParamDialog(value));
  }

  /**
   *
   * @param {GenericLinkedResource} resource
   */
  private openModifyParamDialog(resource: GenericLinkedResource) {
    this.openDialog(resource, (res) => this.resourceParamModalFactory(res));
  }

  /**
   * @param param
   */
  protected onParamUpdate(param) {
    this.linkedResourceParams
      .filter((p) => p.resourceUri === param._links.self.href)
      .forEach((p) => p.label = param.label + ' -> ' + param.value);
  }

  /**
   *
   * @param parameter
   * @returns {ModalRef}
   */
  private resourceParamModalFactory(parameter) {
    const compRef = this.modalService.open(ModifyParameterComponent);
    compRef.componentInstance.parameter = parameter;
    compRef.componentInstance.fileList = this.fileList;
    compRef.componentInstance.enableDelete = true;
    compRef.componentInstance.featureLevel = this.featureLevel;
    compRef.componentInstance.afterDelete.subscribe(() => this.afterDelete.emit());
    compRef.componentInstance.afterUpdate.subscribe((param) => this.onParamUpdate(param));
    return compRef;
  }

  protected createParam() {
   /* Implement in inheriting classes */
  }

  protected createParamsFromXML() {
    /* Implement in inheriting classes */
  }

  /**
   *
   * @param {GenericLinkedResource} resource
   * @param componentFactory
   */
  protected openDialog(resource: GenericLinkedResource, componentFactory) {
    let compRef;
    const onFullfill = () => {
      resourceHandler.refresh();
      this.modalResourceSubscription.unsubscribe();
    };

    const onError = () => {
      this.modalResourceSubscription.unsubscribe();
    };

    const resourceHandler = this
      .genericService
      .findServiceForResource(resource.href);

    this.modalResourceSubscription = resourceHandler
      .loadAndGet()
      .subscribe((item) => {
        if (compRef) {
          compRef.close();
          compRef = null;
        }

        if (isNullOrUndefined(item)) {
          compRef = null;
        } else {
          compRef = componentFactory(item);
          compRef.result.then(onFullfill, onError);
        }
      });
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/parameters/components/parameter-list/parameter-list.component.ts